import React, { Component } from "react"
import { Table, Row, Pagination, Button, Icon, message,Tooltip } from "antd"
import "./Index.scss"
import downloadIcon from "app/styles/images/sp/download.svg"
import warningIcon from "app/styles/images/sp/data-warning.svg"
import FlexableFileName from "app/components/normal/FlexableFileName"
import PushModal from './PushModal'
import config from "app/config"
import { observer, inject } from 'mobx-react'
import pushIcon from 'app/styles/images/sp/push.svg'
import { PREPARE_RUN, RUNNING } from 'app/utils/const'
import CompareModal from "./CompareModal"



@inject('auth') @observer
export default class ReportDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false,
      activeReportIndex: 0,
      currentPage: 1,
      reportListArr: [],
      pushModalShowed: false,
      compareModalShowed: false,
      syncBtnLoading: false,
      STSAnomalyArr:[]
    }
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  closeModal = (field) => {
    this.setState({
      [field]: false,
    })
  }

  componentWillMount() {
    this.initNav(this.props.index)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index) {
      this.initNav(nextProps.index)
    }
  }

componentDidMount() {
  // this.initStsArr();
}

componentDidUpdate(prevProps) {
  // 对比前后props，reportDetail发生变化时重新初始化
  if (this.props.reportDetail !== prevProps.reportDetail) {
     this.setState({ STSAnomalyArr: [] });
  }
}

// 抽离初始化逻辑，复用
initStsArr = () => {
  const { reportDetail } = this.props;
  const stsData = reportDetail && reportDetail.sts;
  console.log('原始数组：', stsData);

  if (stsData && typeof stsData === 'object') {
    const initialAnomalyArr = [];
    const titleList = Object.keys(stsData);
    for (const title of titleList) {
      const val = stsData[title];
      if (val !== "+" && val !== "-") {
        initialAnomalyArr.push(title);
      }
    }
    console.log('初始化默认选中数组：', initialAnomalyArr);
    this.setState({ STSAnomalyArr: initialAnomalyArr });
  }
}

  initNav = (index) => {
    this.setState({
      activeReportIndex: index,
      currentPage: Math.floor(index / 10) + 1
    })
  }

  buttonClick = (template, id) => window.open(`${config.backend}/azf/reports/preview/${id}?templateId=${template}`)

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  changeReport = (index, record) => {
    this.refs.content.scrollTop = 0
    this.setState({
      activeReportIndex: index
    }, () => {
      this.initStsArr();
    })
    this.props.dataSwitch(index, record)
  }

  changePage = (e) => {
    let activeReportIndex = (e - 1) * 10
    let record = this.props.reportList[activeReportIndex]

    this.renderReportList(e)
    this.setState({
      currentPage: e,
      activeReportIndex
    })
    this.changeReport(activeReportIndex, record)
  }

  renderReportList = (pageNumber) => {
    let { reportList } = this.props.data
    let reportListArr = []
    let endNum = pageNumber * 10
    if (endNum > reportList.length) {
      endNum = reportList.length
    }
    for (let currenNum = (pageNumber - 1) * 10; currenNum < endNum; currenNum++) {
      const { state } = reportList[currenNum]

      if (state !== PREPARE_RUN && state !== RUNNING) {
        reportListArr.push(
          <li
            key={currenNum}
            onClick={() => this.changeReport(currenNum, reportList[currenNum])}
            className={this.state.activeReportIndex === currenNum ? "active report" : "report"}
          >
           {/* {reportList[currenNum].sampleName} */}
            {this.renderSampleName(reportList, currenNum)}
          </li>
        )
      }
    }
    return reportListArr
  }
  renderSampleName = (reportList, currenNum) => {
      const { hospitalSampleName, sampleName } = reportList[currenNum]
    var sample=''
    if(hospitalSampleName){
       sample = hospitalSampleName +'  ('+ sampleName+')'
    }else{
       sample = sampleName
    }
      if (sample && sample.length > 23) {
        return (
          <Tooltip placement="left" title={sample}>
            {sample.slice(0, 23) + '...'}
          </Tooltip>
        )
      }
      return sample
    }

  /**
   * 解析文本中的 \n 为虚拟 <br /> 结点
   */
  parseEnter(str) {
    if (!str || typeof str !== "string") {
      return null
    }

    const strs = str.split("\n")
    const result = []

    for (var i = 0; i < strs.length - 1; i++) {
      result.push(strs[i], <br />)
    }
    return result
  }

  renderAppVersion = (reportDetail) => {
    if (reportDetail.application && reportDetail.application.appVersion) {
      return (
        <p>{reportDetail.application.appVersion}</p>
      )
    } else {
      return '-'
    }
  }

  handleSyncSampleInfo = (reportId) => {
    const { syncSampleInfo, getDetailData } = this.props.store
    this.setState({ syncBtnLoading: true })
    syncSampleInfo(reportId)
      .then(res => {
        message.success('同步成功')
        getDetailData(reportId)
        this.setState({ syncBtnLoading: false })
      }, err => {
        this.setState({ syncBtnLoading: false })
        message.error(err.message)
      })
  }
addAllReportResCnv=(record)=>{
  // console.log('添加标记',record)
  this.setState(prevState => {
    // 查找数组中是否已经存在同一个record对象
    const hasSameRecord = prevState.STSAnomalyArr.some(item => item === record)
    // 存在直接返回原state，不做更新
    if (hasSameRecord) return prevState
    // 不存在则追加
    return {
      STSAnomalyArr: [...prevState.STSAnomalyArr, record]
    }
  }, () => {
    // 状态更新完成后打印最新数组
    // console.log(this.state.STSAnomalyArr)
  });
}
delAllReportResCnv=(record)=>{
  //  console.log('删除标记', record)
  this.setState(prevState => {
    // 过滤掉同一引用的对象
    const newList = prevState.STSAnomalyArr.filter(item => item !== record)
    return { STSAnomalyArr: newList }
  }, () => {
    // 删除完成后打印最新数据验证
    // console.log('删除后列表', this.state.STSAnomalyArr)
  });
}
  render() {
    const {
      currentPage,
      pushModalShowed,
      syncBtnLoading,
      compareModalShowed,
    } = this.state
     const userInfo = this.props.auth.userInfo
    let {
      data = {},
      reportDetail,
      templates,
      groupId,
      auth: { pushAuth = {} },
    } = this.props

    let dataColumns = [
      {
        title: (<div className="ta-c">Total Reads</div>),
        className: "ta-c",
        dataIndex: "Total Reads",
      }, {
        title: (<div className="ta-c">High Quality(%)</div>),
        className: "ta-c",
        dataIndex: "High Quality(%)",
      }, {
        title: (<div className="ta-c">Mapping Rate(%)</div>),
        className: "ta-c",
        dataIndex: "Mapping Rate(%)",
      }, {
        title: (<div className="ta-c">Unique Reads</div>),
        className: "ta-c",
        dataIndex: "Unique Reads",
      }, {
        title: (<div className="ta-c">GC(%)</div>),
        className: "ta-c",
        dataIndex: "GC(%)",
      }, {
        title: (<div className="ta-c">Library Quality</div>),
        className: "ta-c",
        dataIndex: "Library Quality",
      }
    ]

    dataColumns.splice(1, 0, {
      title: (
        <div className="ta-c">
          {data.appName === 'AZF_PGM' ? 'Average Length' : 'Trimmomatic Ratio'}
        </div>
      ),
      className: "ta-c",
      dataIndex: data.appName === 'AZF_PGM' ? 'Average Length' : 'Trimmomatic Ratio'
    })
    
    const blockInfodataColumns = [
      {
        title: (<div className="ta-c">区域</div>),
        className: "ta-c",
        dataIndex: "blockArea",
        width: 150,  
      },
      {
        title: (<div className="ta-c">检测信号值</div>),
        className: "ta-c",
        dataIndex: "testValue",
        width: 150,  
      }
    ]

    const sampleInfoColumns = [
      {
        title: "Number",
        dataIndex: "id",
        width: 150,
      }, {
        title: "Sample Name",
        dataIndex: "sampleName",
        width: 150,
      }, {
        title: "Filename",
        dataIndex: "filename",
        width: 150,
        render: (text) => (
          <FlexableFileName
            filename={text}
          />
        )
      }, {
        title: "Reference",
        dataIndex: "reference",
        width: 150,
        render: (text) => {
          return (
            <div>{text ? "是" : "否"}</div>
          )
        }
      }
    ]
    const PGM_STSColumns = [
      {
        title: "sY84",
        dataIndex: "sY84",
        width: 110,
      },
      {
        title: "sY86",
        dataIndex: "sY86",
        width: 110,
      },
      {
        title: "sY127",
        dataIndex: "sY127",
        width: 110,
      },
      {
        title: "sY134",
        dataIndex: "sY134",
        width: 110,
      },
      {
        title: "sY1191",
        dataIndex: "sY1191",
        width: 110,
      },
      {
        title: "sY254",
        dataIndex: "sY254",
        width: 110,
      },
      {
        title: "sY255",
        dataIndex: "sY255",
        width: 110,
      },
      {
        title: "sY255_sY254",
        dataIndex: "sY255_sY254",
        width: 110,
      }
    ]
    const columnTitles = [
  "EHMT1","ZFX","ZFY","SRY","sY81","sY82","sY1064","sY86","sY84","sY1323",
  "sY608","sY1065","sY88","sY182","sY105","sY850","sY2832","sY2833","sY117","sY121",
  "sY124","sY127","sY134","sY802","sY1192","sY153","sY856","sY145","sY1191","sY2713",
  "sY239","sY242","sY255","sY254","sY152","sY157","sY2928","sY160"
];
// 批量生成STSColumns，统一render逻辑
const STSColumns = columnTitles.map(title => {
  return {
    title: title === 'sY160' ? <span style={{ color: 'red' }}>{title}</span> : title,
    dataIndex: title,
    render: (val, record) => {
      const valStr = String(val ? val : "");
      const { STSAnomalyArr } = this.state;
      // console.log('默认',STSAnomalyArr)
      // 值为 + / - 直接隐藏按钮
      const showBtn =valStr && valStr !== "+" && valStr !== "-";
      // 判断当前title是否已在选中数组内
      const isExist = STSAnomalyArr.some(item => item === title);

      return (
        <div>
          <span style={{ color: title === 'sY160' ? 'red' : 'inherit' }}>{val && typeof val === 'string' ? val.replace('(M)', '') : val}</span>
          {showBtn && (
            <div style={{ display: 'inline-block', marginLeft: '10px' }}>
              {!isExist ? (
                <Icon
                  className="add-all-icon"
                  type="plus-circle"
                  onClick={() => this.addAllReportResCnv(title)}
                />
              ) : (
                <Icon
                  className="minus-all-icon"
                  type="minus-circle"
                  onClick={() => this.delAllReportResCnv(title)}
                />
              )}
            </div>
          )}
        </div>
      )
    }
  }
})


    return (
      <Row type="flex" className="azf-report-detail">
        <div ref="content" className="content">
          <div id="detailTop" className="detail-card border-left-paimary first">
            <div className="pull-right">
              {templates !== undefined ? templates.map((item) => {
                if (item.type === "data" && item.format === "html") {
                  return (
                    <Button
                      key={item.id + "html"}
                      type="primary"
                      size="large"
                      onClick={(e) => {
                        this.buttonClick(item.id, reportDetail.reportId)
                      }}
                    >
                      <Icon type="book" />
                      打开报告
                    </Button>
                  )
                } else if (item.type === "data" && item.format === "pdf") {
                  return (
                    <Button key={item.id + "pdf"}
                      type="primary"
                      size="large"
                      onClick={(e) => this.buttonClick(item.id, reportDetail.reportId)}
                    >
                      <Icon type="file-pdf" />
                      PDF 下载
                    </Button>
                  )
                } else {
                  return ""
                }
              }) : ""}
            </div>
            <div className="info-group">
              <label>数据类型：</label>
              <p>{data ? data.appName : ""}</p>
            </div>
            <div className="info-group">
              <label>所在分组：</label>
              <p>{data.groupName}</p>
            </div>
            <div className="info-group">
              <label>应用版本：</label>
              {this.renderAppVersion(reportDetail)}
            </div>
            <div className="info-group">
              <label>核型信息：</label>
              <span>{reportDetail.karyotype || '-'}</span>
              <Button
                loading={syncBtnLoading}
                className="synchronous-btn "
                size="small"
                type="primary"
                onClick={() => this.handleSyncSampleInfo(reportDetail.reportId)}
              >
                同步
              </Button>
            </div>
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">样本信息</h3>
            <Table
              className="azf-sample-info-table"
              columns={sampleInfoColumns}
              rowKey={(record, index) => `${record.id}-sample-info-${index}`}
              dataSource={reportDetail.datas ? reportDetail.datas.slice() : []}
              pagination={false}
            />
            {
              (!this.isEmptyObj(reportDetail) && reportDetail.qualityState !== 0)  // 质控通过不渲染  不通过才渲染
              && (
                <div className="qc-content">
                  <img className="warning-icon" src={warningIcon} alt="" />
                  {reportDetail.qualityContent}
                </div>
              )
            }
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              <a>数据统计信息</a>
            </h3>
            <Table
              columns={dataColumns}
              rowKey={record => record.id + "statistical"}
              dataSource={
                (!this.isEmptyObj(reportDetail) && Object.keys(reportDetail.statistical).length > 0)
                  ? [reportDetail.statistical] : []
              }
              pagination={false}
            />
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              <a>区域检测信号值</a>
            </h3>
            <Table
              columns={blockInfodataColumns}
              rowKey={(record, index) => index + "blockInfoList"} 
              dataSource={reportDetail && reportDetail.blockInfoList && 
                reportDetail.blockInfoList.length > 0 ? 
                reportDetail.blockInfoList : []
              }
              style={{ width: '300' }} 
              pagination={false}
            />
          </div>
          <div className="detail-card">

            <div className="title-wrapper">
              <h3 className="border-left-primary detail-card-title">
                报告结果
              </h3>
              {reportDetail.status === 3 && (
                <div>
                  <a
                    className="point-link"
                    onClick={() => this.showModal("compareModalShowed")}
                  >
                    报告结果对比
                  </a>
                </div>
              )}
            </div>

            <div className="font-14">
              {
                !this.isEmptyObj(reportDetail) && (this.parseEnter(reportDetail.result) || "暂无结果")
              }
            </div>
           
          </div>

          <div className="detail-card">
            <div className="title-wrapper">
              <h3 className="border-left-primary detail-card-title">
                STS位点检测结果
                <span className="sts-select-all-buttons">
                  <Icon
                    className="add-all-icon"
                    type="plus-circle"
                    onClick={() => {
                      this.initStsArr();
                    }}
                  />
                  <Icon
                    className="minus-all-icon"
                    type="minus-circle"
                    onClick={() => {
                      this.setState({ STSAnomalyArr: [] });
                    }}
                  />
                </span>
              </h3>
            </div>
            {(data && data.appName === 'AZF_PGM') && (
              <Table
                columns={PGM_STSColumns}
                rowKey={record => record.id + "sts"}
                dataSource={
                  (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                }
                pagination={false}
              />
            )}
           
            {(data && data.appName === 'AZF_Miseq') && (
              <div>
                <span className="blue-text">内参：</span>
                <Table
                  columns={STSColumns.slice(0, 4)}
                  rowKey={record => record.id + "sts"}
                  dataSource={
                    (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                  }
                  pagination={false}
                  style={{ width: '33%' }}
                />
                <span className="blue-text">AZFa：</span>
                <Table
                  columns={STSColumns.slice(4,14)}
                  rowKey={record => record.id + "sts"}
                  dataSource={
                    (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                  }
                  pagination={false}
                  style={{ width: '83%' }}
                />
                <span className="blue-text">AZFb：</span>
                 <Table
                  columns={STSColumns.slice(14,26)}
                  rowKey={record => record.id + "sts"}
                  dataSource={
                    (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                  }
                  pagination={false}
                />
                <span className="blue-text">AZFc：</span>
                 <Table
                  columns={STSColumns.slice(26)}
                  rowKey={record => record.id + "sts"}
                  dataSource={
                    (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                  }
                  pagination={false}
                />
              </div>
            )}

          </div>
         
          <div className="detail-card" >
            <h3 className="border-left-primary detail-card-title">
              扩增子区域拷贝数变异值
            </h3>
            <div>
              <img alt="" src={!this.isEmptyObj(reportDetail) ? reportDetail.image.ReportInfoBlock : []} />
            </div>
          </div>
           {(userInfo&&userInfo.id !== '1082') && (
            <div>
                <div className="detail-card">
                  <h3 className="border-left-primary detail-card-title">
                    探针检测信号值
                  </h3>
                  <div>
                    <img alt="" src={!this.isEmptyObj(reportDetail) ? reportDetail.image.ReportInfoPre : []} />
                  </div>
                </div>
                {(reportDetail && reportDetail.image&& reportDetail.image.ReportInfoPreRevised ) && (
                    <div className="detail-card">
                      <h3 className="border-left-primary detail-card-title">
                        探针修正后信号值
                      </h3>
                      <div>
                        <img alt="" src={!this.isEmptyObj(reportDetail) ? reportDetail.image.ReportInfoPreRevised : []} />
                      </div>
                    </div>
                )}
                </div>
               )}
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              运行信息
            </h3>
            <div>
              <div className="font-14">
                <span className="blue-text">taskId：</span>{!this.isEmptyObj(reportDetail) ? reportDetail.taskId : ""}
              </div>
              <div className="font-14">
                <span className="blue-text">reportId：</span>
                {!this.isEmptyObj(reportDetail) ? reportDetail.reportId : ""}
              </div>
            </div>
          </div>

          <div className="wrapper-download">
            <a
              href={`${config.backend}/azf/reports/${!this.isEmptyObj(reportDetail) && reportDetail.reportId}/download`}
              title="下载生信分析结果"
              className="download"
            >
              <img src={downloadIcon} alt="下载" />
            </a>
          </div>
          {pushAuth.notifyLimsAzf && (
            <div className="wrapper-push">
              <a
                onClick={() => this.showModal('pushModalShowed')}
                title="推送报告"
                className="push"
              >
                <img src={pushIcon} alt="推送" />
              </a>
            </div>
          )}
        </div>
        <div className="reportNav">
          <div className="title">本组数据</div>
          <ul className="reports">
            {data.reportList && this.renderReportList(currentPage)}
          </ul>
          <Pagination
            className="pagination"
            size="small"
            pageSize={10}
            total={
              (data.reportList || []).filter(item =>
                item.state !== PREPARE_RUN && item.state !== RUNNING
              ).length
            }
            current={currentPage}
            onChange={(e) => this.changePage(e)}
          />
        </div>
        {pushModalShowed && (
          <PushModal
            data={data}
            reportDetailResult={reportDetail.result}
            STSAnomalyArr={this.state.STSAnomalyArr}
            store={this.props.store}
            groupId={groupId}
            key={record => record.id}
            closeModal={() => this.closeModal('pushModalShowed')}
          />
        )}
         {compareModalShowed && (
          <CompareModal
            store={this.props.store}
            detailData={reportDetail}
            data={data}
            closeModal={this.closeModal}
          />
        )}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/azf/ReportDetail/index.js